/* src/app/components/lead-details/health-assessment-list/health-assessment-list.component.css */
/*# sourceMappingURL=health-assessment-list.component-KXQJ6SXG.css.map */
